import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

const LoadingSpinner = ({ size = 'default', className = '' }) => {
  const sizeClasses = {
    tiny: 'h-3 w-3',
    small: 'h-5 w-5',
    default: 'h-8 w-8',
    large: 'h-12 w-12'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <ArrowPathIcon 
        className={`${sizeClasses[size] || sizeClasses.default} animate-spin text-brand-teal`}
        aria-hidden="true"
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoadingSpinner; 